import { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";                    

// images
import card01 from "../assets/image/Partner/intralox.png"    
import card02 from "../assets/image/Partner/baylesa.png"  
import card03 from "../assets/image/Partner/vendee-concept.png"  
import card04 from "../assets/image/Partner/lenke.png"  
import card05 from "../assets/image/Partner/Farzena.png"  
import card06 from "../assets/image/Partner/thaimechtech.png"
import card07 from "../assets/image/Partner/PKM.png"
import card08 from "../assets/image/Partner/polysto.png"     
import card09 from "../assets/image/Partner/Vikan.png"
import card10 from "../assets/image/Partner/goodway.png"    
import card11 from "../assets/image/Partner/VAlign.png"
import card12 from "../assets/image/Partner/Arandu.png"
import card13 from "../assets/image/Partner/ForceXtech.png"     


const sections = [
    
{     
no:"01.",
title:`CONVEYOR TECHNOLOGY & HYGIENIC DESIGN`,
 items: [
      {

        src: card01, 
             name:`Intralox & Commercial Food Sanitation (CFS)`,
        location:`USA — Conveyor Belting & Hygienic Design Standards`,
        description:`Intralox's modular plastic conveyor belts first revolutionised the meat and poultry industry more than 50 years ago. Today their ThermoDrive and modular belt systems are the global standard for hygienic conveyance — engineered specifically for the wet, high-throughput environments that poultry processing demands. The Intralox FoodSafe System combines products, services, and training to achieve the best possible outcomes in uptime, throughput, and food safety.Commercial Food Sanitation (CFS), an Intralox company, are one of the world's foremost authorities on hygienic design. PthruP is formally trained and aligned with CFS standards, applying their 10 Principles of Hygienic Design to every conveyor and facility project — eliminating the hidden contamination risks that cause Listeria and Salmonella outbreaks at the source.`,
        why:`Conveyor systems designed from the ground up to be clean — not just cleaned. Faster washdown, fewer pathogen risks, and a facility built to pass the toughest food safety audits.`,
        website:"www.intralox.com"

  },
 ],
},

{
no:"02.",
title:`CONSULTING & PROCESS EXPERTISE`,
 items: [
      {
         src: card12, 
        name:`Arandu`,
        location:`Brazil — Poultry Processing Consulting & Plant Layout`,
        description:`Founded by Gustavo Ribeiro, Arandu brings over 30 years of hands-on experience in poultry and food processing across Brazil and international markets. Their expertise spans process and plant layout design, full processing line implementation, global equipment and ingredient connections, and evaluation of emerging suppliers and technologies. Brazil's poultry industry operates at a scale and standard that few countries match — and Arandu gives PthruP direct access to that depth of knowledge.`,
        why:`Global best practices applied locally. Your facility benefits from process knowledge built across some of the world's most productive and demanding poultry operations.`,
  },
 ],
},

{
no:"03.",
title:`PROCESSING EQUIPMENT — BRAZIL`,
 items: [
      {
 src: card04, 
        name:`Lenke`,
location:`Brazil — Poultry Processing Equipment`,
description:`Lenke are a specialist Brazilian manufacturer of poultry processing equipment, with deep experience in the high-volume, export-oriented processing segment. Their equipment, especially their well designed and calibrated Graders, is built to the hygiene and throughput standards demanded by the world's most demanding buyers — and is proven in some of Brazil's largest processing operations.`, 
why:`Robust, high-throughput processing equipment from a manufacturer that has been tested at industrial scale in one of the world's most competitive poultry markets.`,
website:"www.lenke.com.br"


  },
  {
 src: card05, 
    name:`Farenzena`,
location:`Brazil — Poultry Processing & Automation`,
description:`Farenzena brings specialist expertise in poultry processing and automation from the Brazilian market. Their solutions, like the Whole Bird packers, are designed for efficiency, hygiene, and consistency — developed in an industry that demands global export standards as a baseline. Farenzena's technology complements the broader Brazilian partner portfolio that PthruP brings to Indian processors.`,
why:`Automation and processing technology from a market where efficiency and hygiene are non-negotiable — now available to Indian processors through PthruP.`,
website:"www.Farenzena.com.br"
  }
 ],
},
{
no:"04.",
title:`PROCESSING EQUIPMENT — EUROPE`,
 items: [
      {
 src: card02, 
        name:`Bayle`,
location:`France — Founded 1932 | Poultry Processing Lines`,
description:`Bayle is a French manufacturer of poultry processing equipment, recognised for its know-how for over 85 years, with international presence in more than 45 countries. Now the leading French company for poultry processing equipment, Bayle stands out through an innovation strategy driven by an internal R&D department that develops the technologies of tomorrow. Their equipment covers every stage of the processing line — from bird handling, scalding, and plucking to evisceration, chilling, grading, and washing — for all types of poultry.`,
why:`Nearly a century of poultry-specific engineering, with equipment proven in industrial facilities across the world and a track record of continuous innovation in hygiene and automation.`,
website:"www.baylesa.com"


  },
  {
     src: card03, 
    name:`Vendée Concept`,
location:`France — Founded 1991 | Automation & Intelligent Grading`,
description:`Vendée Concept specialises in automated equipment for the food processing industry with expertise in poultry, seafood, and meat, offering tailored solutions through two product lines — CALIBRA and MÉCA — available as complete production lines or for integration with existing systems. Technological innovation is ingrained in their DNA, with particular expertise in dynamic weighing and industrial process intelligence. Their intelligent grading, batching, and robotisation systems are designed to minimise weight giveaway, reduce labour, and increase line efficiency.`,
why:`Smart, automated systems that reduce your dependence on manual labour, tighten yield control, and bring measurable efficiency gains to your processing line.`,
website:"www.vendee-concept.com"
  }
 ],
},

{
no:"05.",
title:`PROCESSING EQUIPMENT — ASIA`,
 items: [
      {
 src: card06, 
        name:`Thai Mech Tech`,
location:`Thailand — Integrated Processing Equipment & Automation`,
description:`Thai Mech Tech brings Southeast Asian processing expertise and robust, practical engineering to the PthruP portfolio. Thailand has developed a strong poultry equipment industry serving export-oriented processors with high hygiene and efficiency requirements. Their integrated equipment and automation solutions complement our European and Brazilian partners — offering options well-suited to a range of facility sizes and investment levels.`,
why:`Proven equipment from a market that takes food safety and export standards seriously, offering strong value without compromising on hygiene or performance.`,
website:"www.thaimechtech.com"
  },
 ],
},
{
no:"06.",
title:`BUILDING & INFRASTRUCTURE`,
 items: [
      {

     src: card07, 
        name:`PKM`,
    location:`India — Industrial Steel Structures`,
    description:`PKM are industrial steel structure specialists with an established install base across India and a 100,000 sq.ft fabrication facility equipped with modern manufacturing capability. They understand the specific structural demands of food processing environments — supporting heavy equipment, withstanding daily washdown, and remaining stable and cleanable over years of continuous operation.`,
    why:`Locally fabricated, properly engineered structural solutions built by a team that knows Indian processing facilities inside out.`,

  },
  {
    
     src: card08, 
    name:`PolySto`,
    location:`Belgium — Founded 1991 | Hygienic Wall & Floor Cladding`,
    description:`PolySto is a Belgian company with over 30 years of expertise, designing and manufacturing hygienic building materials tailored to demanding industries including food processing, pharmaceuticals, and healthcare — with products used in more than 99 countries worldwide. Their CleanSheet wall and ceiling systems are made from fibre-reinforced polyester — extremely strong, durable, non-corrosive, and easy to clean, designed as a superior alternative to tiled walls and metal sandwich panels that deteriorate and harbour bacteria over time. PolySto's systems are anti-fungal, water-repellent, chemical-resistant, food-safe, and HACCP compliant. Their patented HygiSeal process eliminates the problematic silicone joints that fail under high-pressure cleaning.`,
    why:`Interior surfaces that don't become a hygiene liability over time. Walls and ceilings that are as easy to clean on year ten as they were on day one — and that hold up under the daily demands of industrial washdown.`,
    website:"www.polysto.com"
  }
 ],
},
{
no:"07.",
title:`SANITATION TOOLS`,
 items: [
      {
     src: card09, 
        name:`Vikan`,
    location:`Denmark — 120+ Years in the Industry | Hygienic Cleaning Tools`,
    description:`Colour coding of cleaning tools was invented by Vikan and is now an industry standard across most of the world — reducing the risk of cross-contamination by ensuring tools are only ever used in their intended zones. Vikan was the first to apply hygienic design principles to cleaning tools for food and beverage companies, and the practice is now a requirement for BRCGS, SQF, and FSSC 22000 certification. Their Ultra Safe Technology (UST) range represents the most advanced hygienic cleaning tools available — with materials, construction, and traceability features that meet the requirements of the world's most demanding processing facilities.`,
    why:`Zone discipline enforced through the tools themselves. Cleaning that is consistent, auditable, and built around preventing contamination — not just removing it.`,
    website:"www.vikan.com"
  },
 ],
},
{
no:"08.",
title:`CONVEYOR BELT CLEANING`,
 items: [
      {
     src: card10, 
        name:`Goodway Technologies`,
    location:`USA — Industrial Belt & Conveyor Cleaning`,
    description:`Goodway's industrial conveyor belt cleaning systems use the power of steam to clean and sanitise mesh and flat conveyor belts quickly and effectively, using 90% less water than traditional cleaning tools. Their PureBelt system uses high-temperature dry steam to remove fats, oils, allergens, mould, and bacteria from belt surfaces — leaving belts clean, dry, and production-ready with minimal downtime, while reducing changeover and labour cleaning times. Both portable and fixed clean-in-place versions are available, and systems are compatible with modular belts including Intralox.`,
    why:`Cleaner belts, dramatically faster cleaning cycles, significantly less water use, and a proven reduction in one of the most persistent sources of contamination in any processing facility.`,
    website:"www.goodway.com"
  },
 ],
},
{
no:"09.",
title:`END OF LINE AUTOMATION`,
 items: [
      {
         src: card11, 
        name:`V-Align Automation`,
        location:`India — Packer to Palletiser Solutions`,
        description:`V-Align Automation are specialists in end-of-line automation — the critical final stage of a processing facility where product moves from pack-off through accumulation, case erection, case packing, case sealing, and all the way to palletising and stretch wrapping. It is a stage that is often underinvested in Indian facilities, yet carries enormous potential for labour savings, throughput improvement, and packaging consistency. PthruP and V-Align have a formal partnership covering end-of-line and Packer to Palletiser projects across India, with a primary focus on food processing and FMCG. Together we offer customers a single point of accountability for the complete line — from hygienic conveyance through to a palletised, dispatch-ready product. V-Align brings 30 years of automation expertise and PAN India project execution capability. PthruP brings the FoodSafe conveyor and infrastructure layer that feeds the line. The two capabilities are designed to work together seamlessly.`,
        why:`End-of-line automation that is designed as a whole, not bolted together from separate suppliers. One team, one accountability, from the first conveyor to the last pallet.`,
  },
 ],
},

{
no:"10.",
title:`DIGITAL FOOD SAFETY & INDUSTRY 4.0`,
 items: [
      {
         src: card13, 
        name:`ForceXtech`,
        location:`Chennai, India — Digital Food Safety Management & IoT`,
        description:`Founded by Nevin Dadual, ForceXtech brings 23+ years of experience in food processing equipment, Industry 4.0, and IoT. They power the digital food safety management layer of PthruP's offering — moving hygiene records, safety monitoring, and traceability from clipboards into live, auditable digital systems that give management real-time visibility and make audits significantly easier to manage.`,
        why:`Real-time oversight of your facility's food safety performance. Audit-ready data at your fingertips. The ability to respond to any food safety event with speed and confidence.`,
        website:"www.forcextech.com"
}]
}

];




gsap.registerPlugin(ScrollTrigger);

export default function PartnersCards() {
  const sectionRef = useRef();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
gsap.utils.toArray(".service-frame").forEach((card) => {
  const wrapper = card.querySelector(".service-wrapper");

  gsap.fromTo(
    wrapper,
    {
      y: 120,
      rotateX: 120,   // starts leaning away
      scale: 0.94,
      opacity: 0
    },
    {
      y: 0,
      rotateX: 0, // 👈 final tilt from Webflow
      scale: 1,
      opacity: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: card,
        start: "top 80%",
        end: "top 30%",
        scrub: true
      }
    }
  );
});


    // ROWS PARALLAX (subtle horizontal drift)
      gsap.from(".is-row-1", {
        xPercent: 4,
        scrollTrigger: {
          trigger: ".is-row-1",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-2", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-2",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-3", {
        xPercent: -2,
        scrollTrigger: {
          trigger: ".is-row-3",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-4", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-4",
          start: "top 85%",
          scrub: 1
        }
      });

      // TEXT REVEAL (up & down alternating)
      gsap.from(".h2", {
        y: -120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 75%"
        }
      });

      gsap.from(".h2-stroke", {
        y: 120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 75%"
        }
      });
  

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="sections is-overflow partner-cards">
 
     <div className="container-lg">

       {sections.map((section, index) => (
<div key={index} className="sections--container">
  <div className="container-h is-margin-top is-margin-bottom">
    <div className="container-lg">
            <div className="h-row is-row-1">
                <div className="h2-wrap">
                    <h3 className="h3 line-height-wrap"><b className="h2-stroke">{section.no} </b>{section.title}</h3>
                </div>
            </div>

        </div>

  </div>

    {section.items.map((item, i) => (      
    <div className={`service-frame is-${i}`} key={i}>
    <div className={`service-wrapper w-col-12 ${i % 2===0 ? "bg-black is-white" : "" }`}>
        <div className="flex-l-t is-serv-col-1">

            <div className="big-animation-wrapper bg-black">
                <div className="big-animation">
                    <img src={item.src} alt="sections" />
                </div>
            </div>
        </div>
        <div className="flex-v-l-split is-s-card-content">
            <div className="h2-frame container-flex">

                <div className="h2--wrap row-1">
                    <h3 className="h3 line-height-wrap">
                        {item.name}</h3>
                        <h4 className="h3 line-height-wrap">
                        {item.location} | <a href={`https://${item.website}`} target="_blank" rel="noopener noreferrer" className="red">{item.website}</a></h4>
                </div>
              

                    <div className="flex-r--s is-100 is-margin-top">
                    <p className={`text d-90 mobile-max ${i % 2===0 ? "txt-white" : "" }`}>
                        {item.description}
                    </p>
                    
                  

                </div>
            </div>
          
  <div className="flex-r--s is-100">
                        <p className={`text d-90 mobile-max ${i % 2===0 ? "txt-white" : "" }`}>
                            <strong>Why this matters to you:</strong> {item.why}
                        </p>
                    </div>
        </div>

    </div>
</div>
 ))}
   </div>
  ))}
     </div>
    </section>
  );
}